import { TFunction } from 'i18next';
import { IDashboardWidgetBaseConfiguration } from '../../../types/IDashboardWidgetBaseConfiguration';
import { GroupPerTimeType } from './group-per-time-type.enum';
import { DisplayMode } from '@/types/display-mode.enum';

export class BalanceOverTimeWidgetConfiguration implements IDashboardWidgetBaseConfiguration {
  title = 'dashboard.balanceOverTimeWidgetConfiguration.title';
  balanceOverTimeType = GroupPerTimeType.DAY;
  locationId = 0;
  assetTypeIds?: number[] = [];
  periodInDays = 30;
  displayMode = DisplayMode.HIERARCHICAL;

  constructor(t: TFunction) {
    this.title = t(this.title);
  }
}
